import { GridAggregationFunction, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { localeFormatterHelper } from '../../../../../shared/helpers/formatter/localeFormatter.helper';

type PositionWithDiscount = {
  total?: number | null;
  discount?: number | null;
} | null;

/**
 * Footer aggregation that sums the order positions' totals after applying each position's
 * discount (`Σ total × (1 − discount/100)`). Shared by the create and edit order grids so the
 * "after discount" total is defined in a single place.
 *
 * Delivery-cost virtual positions carry discount 0, so they are included at their full total.
 */
export const getTotalAfterDiscountAggregation = (
  positions?: ReadonlyArray<PositionWithDiscount> | null,
): GridAggregationFunction<string, string | null> => ({
  apply: () => {
    const totalAfterDiscount =
      positions?.reduce((acc, el) => {
        if (el?.total != null) {
          acc += el.total * (1 - (el.discount ?? 0) / 100);
        }
        return acc;
      }, 0) ?? 0;
    return localeFormatterHelper.formatNumber(totalAfterDiscount, { returnZero: false });
  },
  label: '',
  columnTypes: ['string'],
});

/**
 * Renders the discount column: the after-discount money total in the aggregation footer cell,
 * and `${value}%` for normal per-position cells. Shared by the create and edit order grids.
 */
export const renderDiscountCell = (params: GridRenderCellParams): string => {
  if (params.aggregation) {
    return params.value ?? '';
  }
  return params.value ? `${params.value}%` : '';
};
